export default __webpack_public_path__ + "static/media/nanyang-school-full-size.c68aa9c9.png";